<template>
	<div
		:class="[variant ? `no-results no-results--${variant}` : 'no-results']"
	>
		<div class="no-results__images">
			<div class="no-results__images-default" v-if="showImageNoResults">
				<img
					class=""
					src="~@/assets/no-results.png"
					alt="no results image"
				/>
			</div>

			<div
				class="no-results__images-condensed"
				v-if="!showImageNoResults"
			>
				<i class="icon icon-search"></i>
			</div>
		</div>

		<div class="no-results__text">
			<h2 class="no-results__text-title">
				{{ renderTitleByVariant }}
			</h2>
			<p class="no-results__text-message">
				{{ renderMessageByVariant }}
			</p>
		</div>
	</div>
</template>

<script>
const DEFAULT_TITLE =
	'We checked under the hood but couldn’t find what you were looking for.';
const DEFAULT_MESSAGE = 'Please search for something less specific.';
const CONDENSED_DEFAULT_TITLE = 'No results were found.';
const CONDENSED_MESSAGE = 'Try adjusting the filters or search criteria.';

export default {
	Name: 'NoResults',

	props: {
		title: {
			type: String,
			default: DEFAULT_TITLE
		},
		message: {
			type: String,
			default: DEFAULT_MESSAGE
		},
		variant: {
			type: String,
			default: 'default',
			validator: function(value) {
				return ['condensed', 'default'].includes(value);
			}
		}
	},
	computed: {
		renderTitleByVariant() {
			if (this.variant === 'condensed') {
				return this.title !== DEFAULT_TITLE
					? this.title
					: CONDENSED_DEFAULT_TITLE;
			}
			return this.title;
		},
		renderMessageByVariant() {
			if (this.variant === 'condensed') {
				return this.message !== DEFAULT_MESSAGE
					? this.message
					: CONDENSED_MESSAGE;
			}
			return this.message;
		},
		showImageNoResults() {
			return this.variant === 'default';
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * No results found
    * Can use SCSS variables = TRUE
*/

.no-results {
	padding: $padding-sm * 9 0;
	margin: 0 auto;
	max-width: 420px;
	text-align: center;

	&.no-results--default {
		&__images {
			&-default {
				height: auto;
			}
		}
		.no-results__text {
			margin-top: $gutter-md;
			&-title {
				font-size: $default-font-size + 4;
				margin-bottom: $gutter-md;
				font-weight: $medium-font-weight;
				line-height: normal;
				@include text-contrast($page-body-bkgd, $white, $black);
			}
			&-message {
				font-size: $default-font-size - 2;
				@include text-contrast($page-body-bkgd, $white, $black);
			}
		}
	}

	&.no-results--condensed {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: $gutter-md;
		text-align: left;

		.no-results__images-condensed {
			display: flex;

			.icon {
				font-size: 32px;
			}
		}

		.no-results__text {
			&-title {
				font-size: $heading-font-size-sm;
				margin: 0;
				font-weight: $medium-font-weight;
				line-height: normal;
				@include text-contrast($page-body-bkgd, $white, $black);
			}
			&-message {
				font-size: $heading-font-size-sm;
				@include text-contrast($page-body-bkgd, $white, $black);
			}
		}
	}
}
</style>
